import React, { useState, FC } from 'react';
import classNames from 'classnames';
import LazyImage from 'dibs-react-lazy-image';
import styles from './HpLazyImageWrapper.scss';

type Props = {
    className?: string;
    imageHeight?: number | string | null;
    imageWidth?: number | string | null;
    useLazyLoad?: boolean;
};

const convertStringToNumber = (value: number | string | null): number => {
    return parseInt(value?.toString() || '', 10);
};

const HpLazyImageWrapper: FC<Props> = ({
    children,
    className,
    imageHeight = 0,
    imageWidth = 0,
    useLazyLoad = true,
}) => {
    const [showShimmer, setShowShimmer] = useState(false);

    const aspectRatio = convertStringToNumber(imageHeight) / convertStringToNumber(imageWidth);

    return (
        <div
            className={classNames(styles.container, className)}
            /**
             * When expressed in percentage, paddingTop, is calculated based on the container width.
             * (unlike height which, obviously, is calculated based on parent container height).
             * This little trick lets us render a correct responsive image placeholder on the server.
             */
            style={{ paddingTop: aspectRatio ? aspectRatio * 100 + '%' : 'unset' }}
        >
            {useLazyLoad ? (
                <>
                    <LazyImage
                        offsetVertical={300}
                        offsetHorizontal={800}
                        placeholderClass={classNames(
                            styles.lazyPlaceholder,
                            showShimmer ? styles.shimmer : ''
                        )}
                        className={className}
                        onContentVisible={() => setShowShimmer(true)}
                        onImageLoaded={() => setShowShimmer(false)}
                        placeholder={' '}
                    >
                        {children}
                    </LazyImage>
                    <noscript aria-hidden="true">{children}</noscript>
                </>
            ) : (
                children
            )}
        </div>
    );
};

export default HpLazyImageWrapper;
